import {RsnDialog, RsnSpinner, cn} from '@raison/ui-kit';
import {Atom, useAtomValue} from 'jotai';
import React from 'react';

export function UploadProgressDialog({progress$}: {progress$: Atom<number>}) {
    const progress = useAtomValue(progress$);
    return (
        <RsnDialog.Window placement='center'>
            <div className='flex flex-col items-center gap-2 px-6 py-4'>
                <div>
                    <RsnSpinner color='neutral100' h={24} w={24} />
                </div>
                <div className='fv-text-l h-5 overflow-hidden text-center'>
                    <div className={cn('transition-transform duration-[400ms]', progress >= 100 && '-translate-y-1/2')}>
                        <div>
                            Uploading files{' '}
                            <span className='fv-text-l-bold inline-block' style={{width: '3ch'}}>{`${progress}%`}</span>{' '}
                        </div>
                        <div>Waiting for server to respond</div>
                    </div>
                </div>
            </div>
        </RsnDialog.Window>
    );
}
